// Mock data for inventory dashboard components
export const mockInventoryMetrics = {
  totalSKUs: 1500,
  activeSKUs: 1200,
  stockUtilization: 85,
  stockTurnover: 4.2,
  avgDaysOnHand: 45,
  stockAccuracy: 98.5,
  lowStockItems: 25,
  outOfStockItems: 5,
  excessStockValue: 75000,
};

export const mockUOMMetrics = [
  {
    uomType: 'Each',
    unitsPerHour: 150,
    totalUnits: 15000,
    avgHandlingTime: 15,
    errorRate: 0.5,
  },
  {
    uomType: 'Case',
    unitsPerHour: 75,
    totalUnits: 7500,
    avgHandlingTime: 30,
    errorRate: 0.8,
  },
  {
    uomType: 'Pallet',
    unitsPerHour: 20,
    totalUnits: 2000,
    avgHandlingTime: 120,
    errorRate: 1.2,
  },
];
